import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MissingBlockDataError } from './InvalidBlockError';
import { RouterLink } from '@angular/router';
import { LanguagePrefixPipe } from "../pipes/language-prefix.pipe";
import { InfoBlock } from 'apps/design4circularity/src/app/models';

@Component({
  selector: 'ca-detail-grid-list',
  imports: [CommonModule, RouterLink, LanguagePrefixPipe],
  template: `
  @if (data){
    <div class="detail-grid-list">
      <h2></h2>
      <div class="detail-grid-items">
      @for (tile of data.content; track $index) {
        <div class="detail-grid-tile">
          <span class="material-symbols-outlined">info</span>
          <h2>{{ tile.content.title }}</h2>
          <div [outerHTML]="tile.content.richText"></div>
          @if (tile.content.cta) {
            @if(tile.content.cta.type === 'intern') {
              <a [routerLink]="tile.content.cta.routerLink | languagePrefix | async">{{ data.cta_label }}</a>
            } @else {
              <a [href]="tile.content.cta.href">{{ data.cta_label }}</a>
            }
          }
        </div>
      }
      </div>
    </div>}
  `,
})
export class DetailGridListComponent implements OnInit {
  @Input() data!: DetailGridListData;

  ngOnInit(): void {
    if (!this.data) throw new MissingBlockDataError(DetailGridListComponent.name);
  }
}

export interface DetailGridListData {
  cta_label: string;
  cssClass: null | string;
  content: Omit<InfoBlock, 'type'>[];
}
